var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-base-checkbox"},[(_vm.checked)?_c('base-icon',{staticClass:"c-base-checkbox__icon has-text-black",attrs:{"width":"26","height":"26","name":"painel/checkbox-checked-icon"}}):_c('base-icon',{staticClass:"c-base-checkbox__icon has-text-black",attrs:{"width":"26","height":"26","name":"painel/checkbox-unchecked-icon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }